import React, { useContext, useRef } from 'react'
import MuiPhoneInput from 'material-ui-phone-number'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import { InputAdornment, IconButton, TextField } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'

const formatPhoneLocal = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 8)
    if (digits.length <= 2) return digits
    if (digits.length <= 5) return `${digits.slice(0, 2)} ${digits.slice(2)}`
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`
}

const CustomPhoneBase = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const { allConfigurationVariables } = customCommonContext

    const shrink = props.shrink ? props.shrink.toString() : 'false'

    const onFocus = (event) => {
        if (props.disableAutocomplete) {
            event.target.removeAttribute('readonly')
        }
        if (props.onFocus) {
            props.onFocus(event)
        }
    }

    const handlePhoneNumberChange = (value, allDetails) => {
        if (props.onError) {
            const divElement = document.querySelector(
                `.MuiInputBase-root.Mui-error input[name="${props.name}"]`,
            )

            // Check if the "Mui-error" class is present
            let isError = false
            if (divElement) {
                if (divElement.parentNode.classList.contains('Mui-error')) {
                    if (props.displayFlag) {
                        let trimmed = value.replace(/[ ()-]/g, '')

                        let substract = trimmed.substring(allDetails.dialCode.length + 1)
                        if (substract.length !== 10) {
                            isError = true
                        } else {
                            isError = false
                        }
                    } else if (props.minChar && props.maxChar) {
                        if (value.length > props.minChar && value.length < props.maxChar) {
                            isError = true
                        } else {
                            isError = false
                        }
                    }
                } else {
                    isError = false
                }
            }

            if (isError) {
                // Handle the error, e.g., log it

                props.onError(true)
            } else {
                // Your logic when there is no error
                if (props.displayFlag) {
                    let trimmed = value.replace(/[ ()-]/g, '')

                    let substract = trimmed.substring(allDetails.dialCode.length + 1)

                    if (substract.length !== 10) {
                        props.onError(true)
                    } else {
                        props.onError(false)
                    }
                    props.onChange(value)
                } else {
                    props.onError(false)
                    props.onChange(value)
                }
            }
        } else {
            props.onChange(value)
        }
    }

    const inputProps = props.disableAutocomplete
        ? { ...props.inputProps, autoComplete: 'new-password', readOnly: true }
        : global?.disableAutocomplete
        ? { ...props.inputProps, autoComplete: 'new-password', name: 'no-autofill-phone' }
        : props.inputProps

    const handlePaste = (e) => {
        if (global?.disablePhonePaste) {
            e.preventDefault()
        }
    }

    // When localFormat is true, use a plain TextField with NN NNN NNN formatting
    // and show the country code as a static prefix
    if (props.localFormat) {
        const configCountryCode =
            allConfigurationVariables && allConfigurationVariables.country_code
                ? allConfigurationVariables.country_code
                : ''

        // If stored value already contains a country code (e.g. "+34 96 732 055"),
        // extract it for the prefix and show only the local part in the input.
        // Otherwise use the config country code as prefix.
        let displayCountryCode = configCountryCode
        let displayValue = props.value || ''
        if (displayValue.startsWith('+')) {
            const match = displayValue.match(/^(\+\d{1,4})\s?(.*)$/)
            if (match) {
                displayCountryCode = match[1]
                displayValue = match[2]
            }
        }

        return (
            <div className="customInput">
                {props.upperLabel ? <label>{props.label}</label> : null}
                <TextField
                    id={props.id}
                    value={displayValue}
                    autoFocus={props.autoFocus}
                    name={props.name}
                    onFocus={onFocus}
                    onBlur={props.onBlur}
                    onChange={(e) => {
                        const formatted = formatPhoneLocal(e.target.value)
                        if (props.onError) props.onError(false)
                        props.onChange(formatted)
                    }}
                    InputProps={{
                        inputProps: { ...inputProps, maxLength: 10 },
                        startAdornment: displayCountryCode ? (
                            <InputAdornment position="start">
                                <span style={{ whiteSpace: 'nowrap', marginRight: 4 }}>
                                    {displayCountryCode}
                                </span>
                            </InputAdornment>
                        ) : (
                            props.startAdornment
                        ),
                        endAdornment:
                            props.endAdornment === 'info' ? (
                                <InputAdornment position="end">
                                    <Tooltip title={props.tooltiptitle}>
                                        <IconButton>
                                            <span className="material-icons">info</span>
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ) : (
                                props.endAdornment
                            ),
                    }}
                    label={props.upperLabel ? null : props.label}
                    size={props.size}
                    disabled={props.disabled}
                    variant={props.variant ? props.variant : 'outlined'}
                    placeholder={props.placeholder || 'NN NNN NNN'}
                    error={props.error}
                    helperText={props.helperText}
                    onPaste={handlePaste}
                    fullWidth
                />
            </div>
        )
    }

    return (
        <div className="customInput">
            {props.displayFlag ? (
                <>
                    <>
                        {props?.upperLabel ? <label>{props.label}</label> : null}
                        <MuiPhoneInput
                            value={
                                props.value
                                    ? props.value
                                    : allConfigurationVariables &&
                                      allConfigurationVariables.country_code
                                    ? allConfigurationVariables.country_code
                                    : '+1'
                            }
                            InputProps={{
                                inputProps: inputProps,
                            }}
                            autoFocus={props.autoFocus}
                            enableLongNumbers={true}
                            name={props.name}
                            onChange={handlePhoneNumberChange}
                            onFocus={onFocus}
                            disableAreaCodes={true}
                            id={props.id}
                            label={props?.upperLabel ? null : props.label}
                            type={props.type}
                            size={props.size}
                            disabled={props.disabled}
                            variant={props.variant ? props.variant : 'outlined'}
                            placeholder={props.placeholder}
                            error={props.error}
                            helperText={props.helperText}
                            disableDropdown={props.disabled}
                            countryCodeEditable={props.countryCodeEditable}
                            onPaste={handlePaste}
                        />
                    </>
                </>
            ) : props.upperLabel ? (
                <>
                    <label>{props.label}</label>
                    <MuiPhoneInput
                        value={
                            props.value
                                ? props.value
                                : allConfigurationVariables &&
                                  allConfigurationVariables.country_code
                                ? allConfigurationVariables.country_code
                                : '+1'
                        }
                        autoFocus={props.autoFocus}
                        name={props.name}
                        // onChange={props.onChange}
                        onChange={handlePhoneNumberChange}
                        onFocus={onFocus}
                        InputProps={{
                            inputProps: inputProps,
                            startAdornment: props.startAdornment,
                            shrink: shrink,
                        }}
                        id={props.id}
                        type={props.type}
                        size={props.size}
                        disabled={props.disabled}
                        variant={props.variant ? props.variant : 'outlined'}
                        placeholder={props.placeholder}
                        error={props.error}
                        helperText={props.helperText}
                        disableCountryCode
                        countryCodeEditable={props.countryCodeEditable}
                        onPaste={handlePaste}
                    />
                </>
            ) : (
                <MuiPhoneInput
                    value={
                        props.value
                            ? props.value
                            : allConfigurationVariables && allConfigurationVariables.country_code
                            ? allConfigurationVariables.country_code
                            : '+1'
                    }
                    autoFocus={props.autoFocus}
                    name={props.name}
                    onChange={handlePhoneNumberChange}
                    onFocus={onFocus}
                    InputProps={{
                        inputProps: inputProps,
                        startAdornment: props.startAdornment,
                        endAdornment:
                            props.endAdornment === 'info' ? (
                                <InputAdornment position="end">
                                    <Tooltip title={props.tooltiptitle}>
                                        <IconButton>
                                            <span className="material-icons">info</span>
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ) : (
                                props.endAdornment
                            ),
                        shrink: shrink,
                    }}
                    id={props.id}
                    label={props.label}
                    type={props.type}
                    size={props.size}
                    disabled={props.disabled}
                    variant={props.variant ? props.variant : 'outlined'}
                    placeholder={props.placeholder}
                    error={props.error}
                    helperText={props.helperText}
                    countryCodeEditable={props.countryCodeEditable}
                    onPaste={handlePaste}
                />
            )}
        </div>
    )
}

const CustomPhoneLocked = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const { allConfigurationVariables } = customCommonContext
    const previousCountryRef = useRef(null)
    const selectedDialCodeRef = useRef(null)
    const lastDeleteActionAtRef = useRef(0)

    const shrink = props.shrink ? props.shrink.toString() : 'false'

    const onFocus = (event) => {
        if (props.disableAutocomplete) {
            event.target.removeAttribute('readonly')
        }
        if (props.onFocus) {
            props.onFocus(event)
        }
    }

    const handlePhoneNumberChange = (value, allDetails) => {
        const currentCountry = allDetails?.countryCode || null
        const currentDialCode =
            allDetails && allDetails.dialCode ? allDetails.dialCode.toString() : null
        const previousCountry = previousCountryRef.current
        const shouldSkipResetForDelete =
            lastDeleteActionAtRef.current > 0 && Date.now() - lastDeleteActionAtRef.current < 250

        // Reset this marker after each change cycle.
        lastDeleteActionAtRef.current = 0

        if (
            currentCountry &&
            previousCountry &&
            currentCountry !== previousCountry &&
            currentDialCode &&
            !shouldSkipResetForDelete
        ) {
            previousCountryRef.current = currentCountry
            props.onChange(`+${currentDialCode}`)
            if (props.onError) {
                props.onError(false)
            }
            return
        }

        if (currentCountry) {
            previousCountryRef.current = currentCountry
        }

        if (currentDialCode) {
            selectedDialCodeRef.current = currentDialCode
        }

        if (props.onError) {
            const divElement = document.querySelector(
                `.MuiInputBase-root.Mui-error input[name="${props.name}"]`,
            )

            // Check if the "Mui-error" class is present
            let isError = false
            if (divElement) {
                if (divElement.parentNode.classList.contains('Mui-error')) {
                    if (props.displayFlag) {
                        let trimmed = value.replace(/[ ()-]/g, '')

                        let substract = trimmed.substring(allDetails.dialCode.length + 1)
                        if (substract.length !== 10) {
                            isError = true
                        } else {
                            isError = false
                        }
                    } else if (props.minChar && props.maxChar) {
                        if (value.length > props.minChar && value.length < props.maxChar) {
                            isError = true
                        } else {
                            isError = false
                        }
                    }
                } else {
                    isError = false
                }
            }

            if (isError) {
                // Handle the error, e.g., log it

                props.onError(true)
            } else {
                // Your logic when there is no error
                if (props.displayFlag) {
                    let trimmed = value.replace(/[ ()-]/g, '')

                    let substract = trimmed.substring(allDetails.dialCode.length + 1)

                    if (substract.length !== 10) {
                        props.onError(true)
                    } else {
                        props.onError(false)
                    }
                    props.onChange(value)
                } else {
                    props.onError(false)
                    props.onChange(value)
                }
            }
        } else {
            props.onChange(value)
        }
    }

    const inputProps = props.disableAutocomplete
        ? { ...props.inputProps, autoComplete: 'new-password', readOnly: true }
        : global?.disableAutocomplete
        ? { ...props.inputProps, autoComplete: 'new-password', name: 'no-autofill-phone' }
        : props.inputProps

    const handlePaste = (e) => {
        if (global?.disablePhonePaste) {
            e.preventDefault()
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Backspace' || event.key === 'Delete') {
            lastDeleteActionAtRef.current = Date.now()
        } else {
            lastDeleteActionAtRef.current = 0
        }

        const input = event.target
        const value = input.value
        const cursorPos = input.selectionStart

        // Protect only selected dial-code prefix, not all leading digits.
        const dialCodeFromSelection = selectedDialCodeRef.current
        const fallbackMatch = value.match(/^\+\d{1,4}/)
        const countryCodeLength = dialCodeFromSelection
            ? `+${dialCodeFromSelection}`.length
            : fallbackMatch
            ? fallbackMatch[0].length
            : 0

        // Prevent backspace/delete from modifying country code
        if (countryCodeLength > 0) {
            if (event.key === 'Backspace' && cursorPos <= countryCodeLength) {
                event.preventDefault()
                return
            }
            if (event.key === 'Delete' && cursorPos < countryCodeLength) {
                event.preventDefault()
                return
            }
        }
    }

    return (
        <div className="customInput">
            {props.displayFlag ? (
                <>
                    <>
                        {props?.upperLabel ? <label>{props.label}</label> : null}
                        <MuiPhoneInput
                            value={
                                props.value
                                    ? props.value
                                    : allConfigurationVariables &&
                                      allConfigurationVariables.country_code
                                    ? allConfigurationVariables.country_code
                                    : '+1'
                            }
                            InputProps={{
                                inputProps: {
                                    ...inputProps,
                                    onKeyDown: handleKeyDown,
                                },
                            }}
                            autoFocus={props.autoFocus}
                            enableLongNumbers={true}
                            name={props.name}
                            onChange={handlePhoneNumberChange}
                            onFocus={onFocus}
                            disableAreaCodes={true}
                            id={props.id}
                            label={props?.upperLabel ? null : props.label}
                            type={props.type}
                            size={props.size}
                            disabled={props.disabled}
                            variant={props.variant ? props.variant : 'outlined'}
                            placeholder={props.placeholder}
                            error={props.error}
                            helperText={props.helperText}
                            disableDropdown={props.disabled}
                            countryCodeEditable={props.countryCodeEditable}
                            onPaste={handlePaste}
                        />
                    </>
                </>
            ) : props.upperLabel ? (
                <>
                    <label>{props.label}</label>
                    <MuiPhoneInput
                        value={
                            props.value
                                ? props.value
                                : allConfigurationVariables &&
                                  allConfigurationVariables.country_code
                                ? allConfigurationVariables.country_code
                                : '+1'
                        }
                        autoFocus={props.autoFocus}
                        name={props.name}
                        // onChange={props.onChange}
                        onChange={handlePhoneNumberChange}
                        onFocus={onFocus}
                        InputProps={{
                            inputProps: {
                                ...inputProps,
                                onKeyDown: handleKeyDown,
                            },
                            startAdornment: props.startAdornment,
                            shrink: shrink,
                        }}
                        id={props.id}
                        type={props.type}
                        size={props.size}
                        disabled={props.disabled}
                        variant={props.variant ? props.variant : 'outlined'}
                        placeholder={props.placeholder}
                        error={props.error}
                        helperText={props.helperText}
                        disableCountryCode
                        countryCodeEditable={props.countryCodeEditable}
                        onPaste={handlePaste}
                    />
                </>
            ) : (
                <MuiPhoneInput
                    value={
                        props.value
                            ? props.value
                            : allConfigurationVariables && allConfigurationVariables.country_code
                            ? allConfigurationVariables.country_code
                            : '+1'
                    }
                    autoFocus={props.autoFocus}
                    name={props.name}
                    onChange={handlePhoneNumberChange}
                    onFocus={onFocus}
                    InputProps={{
                        inputProps: {
                            ...inputProps,
                            onKeyDown: handleKeyDown,
                        },
                        startAdornment: props.startAdornment,
                        endAdornment:
                            props.endAdornment === 'info' ? (
                                <InputAdornment position="end">
                                    <Tooltip title={props.tooltiptitle}>
                                        <IconButton>
                                            <span className="material-icons">info</span>
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ) : (
                                props.endAdornment
                            ),
                        shrink: shrink,
                    }}
                    id={props.id}
                    label={props.label}
                    type={props.type}
                    size={props.size}
                    disabled={props.disabled}
                    variant={props.variant ? props.variant : 'outlined'}
                    placeholder={props.placeholder}
                    error={props.error}
                    helperText={props.helperText}
                    countryCodeEditable={props.countryCodeEditable}
                    onPaste={handlePaste}
                />
            )}
        </div>
    )
}

const CustomPhone = (props) =>
    global?.songvestPhoneLock ? <CustomPhoneLocked {...props} /> : <CustomPhoneBase {...props} />

export default CustomPhone
